'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'user-visor';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'e04c';
var svgPathData = 'M334 176c-18.5 42.4-60.8 72-110 72s-91.5-29.6-110-72l-2 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l22.6 0c22-24.6 53.9-40 89.4-40s67.5 15.4 89.4 40L336 48c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-2 0zM16 482.3C16 383.8 95.8 304 194.3 304l59.4 0c98.5 0 178.3 79.8 178.3 178.3 0 16.4-13.3 29.7-29.7 29.7L45.7 512C29.3 512 16 498.7 16 482.3zM132 112c0 11 9 20 20 20l144 0c11 0 20-9 20-20s-9-20-20-20L152 92c-11 0-20 9-20 20zM311.7 384.7L276.5 455c-4 8 4.5 16.5 12.5 12.5l26.8-13.4c2.6-1.3 5.7-1.3 8.3 0L351 467.5c8 4 16.5-4.5 12.5-12.5l-35.1-70.3c-3.4-6.9-13.3-6.9-16.7 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faUserVisor = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;